/**
 * Badge Category API Types
 * Types for badge category management + badge rarity moderation (admin)
 */

// ===================
// RARITY
// ===================

/** Badge rarity (serialized as the string enum name) */
export type BadgeRarity = 'Common' | 'Rare' | 'Epic' | 'Legendary'

export const BADGE_RARITIES: BadgeRarity[] = ['Common', 'Rare', 'Epic', 'Legendary']

// ===================
// BADGE CATEGORY DTOs
// ===================

/** Badge category (per contract Section 3) */
export interface BadgeCategoryDto {
  id: number
  name: string
  displayName: string
  iconName: string | null // emoji
  color: string | null
  sortOrder: number
  isPlatform: boolean
  isActive: boolean
}

// ===================
// REQUEST TYPES
// ===================

/** Parameters for listing badge categories */
export interface ListBadgeCategoriesParams {
  includeInactive?: boolean
}

/** Request for creating a badge category (isPlatform NOT settable via API) */
export interface CreateBadgeCategoryRequest {
  name: string
  displayName: string
  iconName?: string | null
  color?: string | null
  sortOrder: number
  isActive: boolean
}

/** Request for updating a badge category (isPlatform NOT settable via API) */
export interface UpdateBadgeCategoryRequest {
  name?: string
  displayName?: string
  iconName?: string | null
  color?: string | null
  sortOrder?: number
  isActive?: boolean
}

// ===================
// RARITY MODERATION
// ===================

/** A collection badge row as seen on the rarity-moderation table */
export interface CollectionBadgeModerationDto {
  id: string
  name: string
  collectionId: string
  collectionName: string
  creatorDisplayName: string
  categoryId: number | null
  categoryName: string | null
  rarity: BadgeRarity
  imageUrl: string | null
}

/** Parameters for listing collection badges for moderation */
export interface ListCollectionBadgesParams {
  search?: string
  onlyPending?: boolean
}

/** Request body for setting a collection badge's rarity */
export interface SetBadgeRarityRequest {
  rarity: BadgeRarity
}
